import { render, staticRenderFns } from "./mark-revision-needed.vue?vue&type=template&id=ca0a4bf6&"
import script from "./mark-revision-needed.js?vue&type=script&lang=js&"
export * from "./mark-revision-needed.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports